"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MeetingSessionStatus_1 = require("../meetingsession/MeetingSessionStatus");

var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");

var MeetingSessionTURNCredentials_1 = require("../meetingsession/MeetingSessionTURNCredentials");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var SignalingClientJoin_1 = require("../signalingclient/SignalingClientJoin");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var BaseTask_1 = require("./BaseTask");
/*
 * [[JoinAndReceiveIndexTask]] sends the JoinFrame and asynchronously waits for the server to send the [[SdkIndexFrame]].
 * It should run with the [[TimeoutTask]] as the subtask so it can get canceled after timeout.
 */


var JoinAndReceiveIndexTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(JoinAndReceiveIndexTask, _BaseTask_1$default);

  var _super = _createSuper(JoinAndReceiveIndexTask);

  function JoinAndReceiveIndexTask(context) {
    var _this;

    _classCallCheck(this, JoinAndReceiveIndexTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'JoinAndReceiveIndexTask';
    _this.taskCanceler = null;
    _this.maxVideos = 25;
    return _this;
  }

  _createClass(JoinAndReceiveIndexTask, [{
    key: "cancel",
    value: function cancel() {
      if (this.taskCanceler) {
        this.taskCanceler.cancel();
        this.taskCanceler = null;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var indexFrame;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve, reject) {
                  var context = _this2.context;
                  context.turnCredentials = null;

                  var IndexFrameInterceptor = /*#__PURE__*/function () {
                    function IndexFrameInterceptor(signalingClient) {
                      _classCallCheck(this, IndexFrameInterceptor);

                      this.signalingClient = signalingClient;
                    }

                    _createClass(IndexFrameInterceptor, [{
                      key: "cancel",
                      value: function cancel() {
                        this.signalingClient.removeObserver(this);
                        reject(new Error("JoinAndReceiveIndexTask got canceled while waiting for SdkIndexFrame"));
                      }
                    }, {
                      key: "handleSignalingClientEvent",
                      value: function handleSignalingClientEvent(event) {
                        if (event.type === SignalingClientEventType_1.default.WebSocketClosed) {
                          var message = "The signaling connection was closed with code ".concat(event.closeCode, " and reason: ").concat(event.closeReason);
                          context.logger.warn(message);
                          var statusCode = MeetingSessionStatusCode_1.default.SignalingBadRequest;

                          if (event.closeCode === 4410) {
                            message = 'The meeting already ended.';
                            context.logger.warn(message);
                            statusCode = MeetingSessionStatusCode_1.default.MeetingEnded;
                          } else if (event.closeCode >= 4500 && event.closeCode < 4600) {
                            statusCode = MeetingSessionStatusCode_1.default.SignalingInternalServerError;
                          }

                          context.audioVideoController.handleMeetingSessionStatus(new MeetingSessionStatus_1.default(statusCode), new Error(message));
                          return;
                        }

                        if (event.type !== SignalingClientEventType_1.default.ReceivedSignalFrame) {
                          return;
                        }

                        if (event.message.type === SignalingProtocol_js_1.SdkSignalFrame.Type.JOIN_ACK) {
                          // @ts-ignore: force cast to SdkJoinAckFrame
                          var joinAckFrame = event.message.joinack;

                          if (joinAckFrame && joinAckFrame.videoSubscriptionLimit) {
                            context.videoSubscriptionLimit = joinAckFrame.videoSubscriptionLimit;
                          }

                          if (joinAckFrame && joinAckFrame.turnCredentials) {
                            context.turnCredentials = new MeetingSessionTURNCredentials_1.default();
                            context.turnCredentials.username = joinAckFrame.turnCredentials.username;
                            context.turnCredentials.password = joinAckFrame.turnCredentials.password;
                            context.turnCredentials.ttl = joinAckFrame.turnCredentials.ttl;
                            context.turnCredentials.uris = joinAckFrame.turnCredentials.uris.map(function (uri) {
                              return context.meetingSessionConfiguration.urls.urlRewriter(uri);
                            }).filter(function (uri) {
                              return !!uri;
                            });
                          } else {
                            context.logger.error('missing TURN credentials in JoinAckFrame');
                          }

                          return;
                        }

                        if (event.message.type !== SignalingProtocol_js_1.SdkSignalFrame.Type.INDEX) {
                          return;
                        }

                        this.signalingClient.removeObserver(this); // @ts-ignore: force cast to SdkIndexFrame

                        var indexFrame = event.message.index;
                        resolve(indexFrame);
                      }
                    }]);

                    return IndexFrameInterceptor;
                  }();

                  var interceptor = new IndexFrameInterceptor(_this2.context.signalingClient);

                  _this2.context.signalingClient.registerObserver(interceptor);

                  _this2.taskCanceler = interceptor;

                  _this2.context.signalingClient.join(new SignalingClientJoin_1.default(_this2.maxVideos, true, _this2.context.meetingSessionConfiguration.applicationMetadata));
                });

              case 2:
                indexFrame = _context.sent;
                this.context.logger.info("received first index ".concat(JSON.stringify(indexFrame))); // We currently don't bother ingesting this into the same places as `ReceiveVideoStreamIndexTask` as we synchronously attempt a first subscribe
                // after this task completes and the state isn't quite in the right place to make it work without some refactoring. However that
                // means that we will always have an initial subscribe without any received videos.

                this.context.indexFrame = indexFrame;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return JoinAndReceiveIndexTask;
}(BaseTask_1.default);

exports.default = JoinAndReceiveIndexTask;